<ng-template #jobTemplate>
  <div class="common-header-flex">
    <div class="f-1">
      <div *ngIf="object?.status != 'ACTIVE' && object?.status != 'DRAFTED'">
        Activate Job </div>
      <div *ngIf="object?.status == 'ACTIVE' || object?.status == 'DRAFTED'">
        Update Job </div>
    </div>
    <div>
      <button>
        <span class="common-close" (click)="cancelJob()">&times;</span>
      </button>
    </div>
  </div>
  <!-- cdkScrollable: registers the modal body with the CDK ScrollDispatcher so
       CDK overlays using the default reposition strategy track their fields on
       form scroll. The Client Name autocomplete no longer depends on it — its
       CloseOnOutsideScrollStrategy (see component providers) listens directly. -->
  <div class="panel-body custom-modal-body border-radius-top-left-right-6" cdkScrollable>
    <form [formGroup]="jobPostForm" action="">
      <div class="row app-form">
        <!-- Job Description - First Section with Professional Parsing UI -->
        <div class="col-sm-12">
          <label class="control-label required-field font-bold" style="font-weight:600;">Job Description</label>
          <p class="jd-hint-text">Paste or type your job description below and click "Parse JD" to auto-fill the form fields.</p>

          <div formControlName="jobDescription" [ngxSummernote]="config2" class="note-editor.note-frame"></div>

          <!-- Validation Errors -->
          <div style="display: flex;justify-content:end; width: 100%;" *ngIf="
            (submit && jobControls.jobDescription?.invalid) ||
            (jobControls.jobDescription?.invalid &&
              (jobControls.jobDescription?.dirty ||
                jobControls.jobDescription?.touched))" class="error-msg mt-1">
            <div *ngIf="jobControls.jobDescription?.errors?.required">
              Job Description is required
            </div>
            <div *ngIf="jobControls.jobDescription?.errors?.minChar">
              Job Description should at least have {{ JOB_DESCRIPTION.min }} Characters
            </div>
            <div *ngIf="jobControls.jobDescription?.errors?.maxChar">
              Job Description can have a maximum of {{ JOB_DESCRIPTION.max }} Characters
            </div>
          </div>
          
          <!-- JD Parsing Action Bar -->
          <div class="jd-parsing-action-bar" style="display: flex; width: 100%;">
            <div class="jd-char-info">
              <small class="char-limit">Maximum of {{ JOB_DESCRIPTION.max }} Characters allowed</small>
            </div>

            <div class="jd-parsing-controls">
              <!-- Parse Button - Always visible when content exists -->
              <button type="button"
                      class="btn btn-primary btn-sm jd-parse-btn"
                      (click)="parseJobDescription()"
                      [disabled]="isJdParsing || !jobControls.jobDescription?.value || jobControls.jobDescription?.value?.trim().length < 100">
                <span *ngIf="!isJdParsing">
                  <ng-icon name="tablerWand" class="me-1"></ng-icon> Parse JD
                </span>
                <span *ngIf="isJdParsing">
                  <ng-icon name="tablerLoader2" class="me-1 spin"></ng-icon>
                  Parsing...
                </span>
              </button>

              <!-- Retry Button - Shows on failure -->
              <button type="button"
                      class="btn btn-warning btn-sm jd-retry-btn"
                      (click)="parseJobDescription()"
                      *ngIf="jdParseFailed && !isJdParsing">
                <ng-icon name="tablerRefresh" class="me-1"></ng-icon> Retry Parse
              </button>
            </div>
          </div>

          <!-- Parsing Status Messages -->
          <div class="jd-parsing-status mt-2">
            <div *ngIf="isJdParsing" class="parsing-status">
              <ng-icon name="tablerLoader2" class="me-2 spin"></ng-icon>
              <small class="text-info">Parsing job description...</small>
            </div>

            <div *ngIf="jdParseSuccess && !isJdParsing">
              <small class="text-info">
                Note: Please review the filled values before submitting.
              </small>
            </div>

            <div *ngIf="jdParseSuccess && !isJdParsing" class="success-status">
              <small class="text-success">
                <ng-icon name="tablerCheck" class="me-1"></ng-icon>
                Job description parsed successfully! Form fields have been auto-filled.
              </small>
            </div>

            <div *ngIf="jdParseFailed && !isJdParsing" class="error-status">
              <small class="text-danger">
                <ng-icon name="tablerAlertCircle" class="me-1"></ng-icon>
                Parsing failed. Please try again or fill the form manually.
              </small>
            </div>
          </div>
        </div>

        <div *ngIf="!showtoggle&&(object?.status === 'ACTIVE'||object?.status === 'INACTIVE')" class="col-sm-6 s-l">
          <div class="panel-tools" *ngIf="object?.jobPostedBy === userId" style="margin-right: 10px;">
            <label class="switch">
              <input [disabled]="true" name="object?.status" [ngModel]="object?.status === 'ACTIVE'"
                [ngModelOptions]="{standalone: true}" type="checkbox">
              <span class="slider round"
                [ngClass]="{'active': object?.status === 'ACTIVE', 'inactive': object?.status === 'INACTIVE'}"></span>
            </label>
          </div>
          <div *ngIf="object?.status === 'ACTIVE'" style="font-size: 16px; font-weight: 600;">Active</div>
          <div *ngIf="object?.status === 'INACTIVE'" style="font-size: 16px; font-weight: 600;">Inactive</div>
        </div>

        <div class="col-sm-12">
          <div class="row">

            <div class="col-sm-6" style="padding-bottom: 15px;">
              <label class="control-label required-field font-bold">Client Type</label>
              <select class="form-control form-group input-sm" (change)="onClientTypeChange($event.target.value)"
                formControlName="clientType" type="text">
                <option value="null" selected disabled>Select Your Client Classification</option>
                <option *ngFor="let client of clientTypeList" [value]="client">
                  {{client}}</option>
              </select>
              <div *ngIf="
                      (submit && jobControls.clientType.invalid) ||
                      (jobControls.clientType.invalid &&
                        (jobControls.clientType.dirty ||
                          jobControls.clientType.touched))
                    " class="error-msg">
                <div *ngIf="jobControls.clientType.errors.required">
                  Client Type is required
                </div>
              </div>
              <div class="custom-checkbox">
                <label class="checkbox-label font-bold" style="text-align: center;margin-top: -4px;"> Show Client
                  Type
                  <input type="checkbox" name="showClientType" formControlName="showClientType">
                  <span class="checkmark" title="You can check or uncheck this to show or hide  client type"></span>
                </label>
              </div>
            </div>

            <div class="col-sm-6" style="padding-bottom: 15px;">
              <label for="clientName" class="control-label required-field font-bold">Client Name</label> <input
                type="text" maxlength="76" placeholder="Organization's Name job created for" matInput
                formControlName="clientName" debounceTime="1000" class="form-control form-group"
                [matAutocomplete]="auto1" (input)="getOrganization1(mytest1.value)" #mytest1 #filterData
                (paste)="onPaste1($event)" />
              <div>
                <ng-container>
                  <mat-autocomplete #auto1="matAutocomplete" panelClass="client-name-autocomplete"
                    [hideSingleSelectionIndicator]="true">
                    <!-- Platform Business partition -->
                    <mat-optgroup label="Platform Business"
                      *ngIf="searchBarShow1 && platformOrgList1?.length > 0">
                      <mat-option *ngFor="let option of platformOrgList1 | slice: 0:20" [value]="option.organizationName"
                        (click)="onChngOrg(option)">
                        <div style="display: grid; row-gap: 0px; line-height: initial;">
                          <div>
                            <strong style="font-size: 13px; padding: 0px 6px 0px 0px;" class="ellipse">
                              {{option.organizationName}}
                            </strong>
                          </div>
                          <div style="    line-height: 10px;">
                            <i>
                              <div style="font-size: 60%;">
                                {{option.address1 }}<span *ngIf="option.address1 && option.address2">{{", "}}</span>
                                {{option.address2}}
                              </div>
                            </i>
                          </div>
                          <div style="    line-height: 10px;">
                            <i>
                              <div style="font-size: 60%;">
                                {{option.street }}<span *ngIf="option.street">{{", "}}</span>
                                {{option.city}}<span *ngIf="option.city">{{", "}}</span>
                                {{option.state}}<span *ngIf="option.state">{{", "}}</span>
                                {{option.countryName}}
                              </div>
                            </i>
                          </div>
                        </div>
                      </mat-option>
                    </mat-optgroup>

                    <!-- Externally-created businesses partition -->
                    <mat-optgroup label="Client Companies"
                      *ngIf="searchBarShow1 && externalOrgList1?.length > 0">
                      <mat-option *ngFor="let option of externalOrgList1 | slice: 0:20"
                        [value]="option.organizationName" (click)="onChngOrg(option, 'EXTERNAL')">
                        <div style="display: grid; row-gap: 0px; line-height: initial;">
                          <div>
                            <strong style="font-size: 13px; padding: 0px 6px 0px 0px;" class="ellipse">
                              {{option.organizationName}}
                            </strong>
                          </div>
                        </div>
                      </mat-option>
                    </mat-optgroup>

                    <!-- Empty state -->
                    <mat-option *ngIf="searchBarShow1 && clientNameSearched1
                        && (!platformOrgList1 || platformOrgList1.length === 0)
                        && (!externalOrgList1 || externalOrgList1.length === 0)"
                        disabled>
                      <span style="font-size: 12px; color: #888; font-style: italic;">
                        No matching businesses
                      </span>
                    </mat-option>
                  </mat-autocomplete>
                </ng-container>
              </div>
              <div *ngIf="(submit && jobControls.clientName.invalid) ||
                        (jobControls.clientName.invalid &&
                          (jobControls.clientName.dirty ||
                            jobControls.clientName.touched))
                      " class="error-msg">
                <div *ngIf="jobControls.clientName.errors.required">
                  Client Name is required
                </div>
                <div *ngIf="jobControls.clientName.errors.minword">
                  {{FORMERROR.CLIENTNAME_MIN}}
                </div>
                <div *ngIf="jobControls.clientName.errors.maxword">
                  {{FORMERROR.CLIENTNAME_MAX}}
                </div>
              </div>
              <div *ngIf="jobControls.clientName.errors?.pattern && jobControls.clientName.touched" class="error-msg">
                Enter valid Client Name
              </div>
              <div class="custom-checkbox">
                <label class="checkbox-label font-bold" style="text-align: center;margin-top: -4px;"> Show Client
                  Name
                  <input type="checkbox" name="showClientName" formControlName="showClientName">
                  <span class="checkmark" title="You can check or uncheck this to show or hide  client name"></span>
                </label>
              </div>
            </div>
          </div>
          <div class="row">

            <div class="col-sm-6" style="padding-bottom: 15px;">
              <label for="jobClassification" class="control-label required-field font-bold">Engagement Type</label>
              <select class="form-control input-sm" formControlName="jobClassification" type="text"
                (change)="onengagementTypeChange($event.target.value)">
                <option value="null" selected disabled>Select Job Classification</option>
                <option *ngFor="let classification of engagementTypeList" [value]="classification">
                  {{classification}}</option>
              </select>
              <div *ngIf="
                  (submit && jobControls.jobClassification.invalid) ||
                  (jobControls.jobClassification.invalid &&
                    (jobControls.jobClassification.dirty ||
                      jobControls.jobClassification.touched))
                " class="error-msg">
                <div *ngIf="jobControls.jobClassification.errors.required">
                  Job Classification is required
                </div>
              </div>
            </div>

            <div class="col-sm-6" style="padding-bottom: 15px;">
              <label for="jobTitle" class="control-label required-field font-bold">Job Title</label>
              <div [attr.title]="selectedJobTitle">
                <ng-select class="multiselectlable gs-clear-plain" [inputAttrs]="{maxlength: '150'}" [items]="candidateJobTitleList" [addTag]="true"
                  [hideSelected]="false" [clearable]="true" dropdownPosition="bottom" formControlName="jobTitle" [multiple]="false"
                  placeholder="Job Title" [(ngModel)]="selectedJobTitle">
                  <ng-template ng-option-tmp let-item="item">
                    <div class="custom-option multi-line-option" [attr.title]="item">
                      {{ item }}
                    </div>
                  </ng-template>
                  <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
                    <div class="selected-item" [attr.title]="item">
                      <span class="ng-value-label">{{ item }}</span>
                    </div>
                  </ng-template>
                </ng-select>
              </div>
              <div *ngIf="
                            (submit && jobControls.jobTitle.invalid) ||
                            (jobControls.jobTitle.invalid &&
                              (jobControls.jobTitle.dirty ||
                                jobControls.jobTitle.touched))
                          " class="error-msg">
                <div *ngIf="jobControls.jobTitle.errors.required">
                  Job Title is required
                </div>
                <div *ngIf="jobControls.jobTitle.errors.minword">
                  {{FORMERROR.JOBTITLE_MIN}}
                </div>
                <div *ngIf="jobControls.jobTitle.errors.maxword">
                  {{FORMERROR.JOBTITLE_MAX}}
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6">
              <div class="col-sm-12 pr-0 pl-0" style="padding-bottom: 15px;">
                <label for="primarySkills" class="control-label required-field font-bold">Primary Skills</label>
                <div>
                  <ng-select class="multiselectlable" [items]="primarySkillsList" [addTag]="true"
                    [clearSearchOnAdd]="true" [hideSelected]="false" dropdownPosition="bottom"
                    formControlName="primarySkills" maxSelectedItems="3" [multiple]="true" [closeOnSelect]="false"
                    [(ngModel)]="primarySkillsSelected" placeholder="e.g. Java, Spring, Hibernate"
                    (clear)="onSkillsCleared('primary')">
                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                      <div class="ng-select-checkbox-label">
                        <span class="ng-select-checkmark" [class.checked]="item$.selected"
                          [class.disabled]="!item$.selected && primarySkillsSelected?.length==3"></span>
                        <span class="ng-select-checkbox-text" [attr.title]="item">{{item}}</span>
                      </div>
                    </ng-template>
                    <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
                      <div class="selected-item" [attr.title]="item">
                        <span class="ng-value-clear remove-icon" (click)="clear(item)">
                          ✕
                        </span>
                        
                        <span class="ng-value-label">{{ item }}</span>
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
                <small style="font-size: 12px;">Enter no more than 3</small>
              </div>
                 <div style="display:flex; float: right;">
                   <div *ngIf="
                     (submit && jobControls.primarySkills.invalid) ||
                     (jobControls.primarySkills.invalid &&
                       (jobControls.primarySkills.dirty ||
                         jobControls.primarySkills.touched))
                   " class="error-msg">
                     <div *ngIf="jobControls.primarySkills.errors.required">
                       Primary Skills is required
                     </div>
                   </div>
                 </div>
            </div>
            <div class="col-sm-6">
              <div class="col-sm-12 pr-0 pl-0" style="padding-bottom: 15px;">
                <label for="secondarySkills" class="control-label font-bold">Secondary Skills</label>
                <div>
                  <ng-select class="multiselectlable" [items]="secondarySkillsList" [addTag]="true"
                    [clearSearchOnAdd]="true" [hideSelected]="false" dropdownPosition="bottom"
                    formControlName="secondarySkills" maxSelectedItems="3" [multiple]="true" [closeOnSelect]="false"
                    [(ngModel)]="secondarySkillsSelected" placeholder="e.g. Java, Spring, Hibernate"
                    (clear)="onSkillsCleared('secondary')">
                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                      <div class="ng-select-checkbox-label">
                        <span class="ng-select-checkmark" [class.checked]="item$.selected"
                          [class.disabled]="!item$.selected && secondarySkillsSelected?.length==3"></span>
                        <span class="ng-select-checkbox-text" [attr.title]="item">{{item}}</span>
                      </div>
                    </ng-template>
                    <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
                      <div class="selected-item" [attr.title]="item">
                        <span class="ng-value-clear remove-icon" (click)="clear(item)">
                          ✕
                        </span>
                        
                        <span class="ng-value-label">{{ item }}</span>
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
                <small style="font-size: 12px;">Enter no more than 3</small>
              </div>
            </div>
          </div>
          
            <div class="col-sm-12 p-0" style="padding-bottom: 20px!important;">
              <div class="row">
                <div class="col-sm-6" style="padding-bottom: 15px;">
                  <label for="location" class="control-label required-field font-bold">Country</label>
                  <select class="form-control input-sm" formControlName="country" type="text"
                    (change)="onChangeCountry($event.target.value)">
                    <option value="null" selected disabled>Country</option>
                    <option *ngFor="let country of countryList" [value]="country.countryCode">
                      {{country.countryName}}</option>
                  </select>
                  <div *ngIf="
                                              (submit && jobControls.country.invalid) ||
                                              (jobControls.country.invalid &&
                                                (jobControls.country.dirty ||
                                                  jobControls.country.touched))
                                            " class="error-msg">
                    <div *ngIf="jobControls.country.errors.required">
                      Country is required
                    </div>
                  </div>
                </div>
                <div class="col-sm-6" *ngIf="jobPostForm.value.country=='IN'">
                  <label for="location" class="control-label required-field font-bold">State</label>
                  <select class="form-control input-sm" formControlName="state" type="text">
                    <option value="null" selected=true disabled>State</option>
                    <option *ngFor="let state of stateListIN" [value]="state.stateName">{{state.stateName}}
                    </option>
                  </select>
                  <div *ngIf="
                              (submit && jobControls.state.invalid) ||
                              (jobControls.state.invalid &&
                                (jobControls.state.dirty ||
                                  jobControls.state.touched))
                            " class="error-msg">
                    <div *ngIf="jobControls.state.errors.required">
                      State is required
                    </div>
                  </div>
                </div>
                <div class="col-sm-6" *ngIf="jobPostForm.value.country=='US'">
                  <label for="location" class="control-label required-field font-bold">State</label>
                  <select class="form-control input-sm" formControlName="state" type="text">
                    <option value="null" selected=true disabled>State</option>
                    <option *ngFor="let state of usStatesList" [value]="state">{{state}}
                    </option>
                  </select>
                  <div *ngIf="
                                            (submit && jobControls.state.invalid) ||
                                            (jobControls.state.invalid &&
                                              (jobControls.state.dirty ||
                                                jobControls.state.touched))
                                          " class="error-msg">
                    <div *ngIf="jobControls.state.errors.required">
                      State is required
                    </div>
                  </div>
                </div>
                <div class="col-sm-6" *ngIf="jobPostForm.value.country=='CA'">
                  <label for="location" class="control-label required-field font-bold">State</label>
                  <select class="form-control input-sm" formControlName="state" type="text">
                    <option value="null" selected=true disabled>State</option>
                    <option *ngFor="let state of stateListCA" [value]="state.stateName">{{state.stateName}}
                    </option>
                  </select>
                  <div *ngIf="
                                            (submit && jobControls.state.invalid) ||
                                            (jobControls.state.invalid &&
                                              (jobControls.state.dirty ||
                                                jobControls.state.touched))
                                          " class="error-msg">
                    <div *ngIf="jobControls.state.errors.required">
                      State is required
                    </div>
                  </div>
                </div>
                <div class="col-sm-6" *ngIf="jobPostForm.value.country=='AU'">
                  <label for="location" class="control-label required-field font-bold">State</label>
                  <select class="form-control input-sm" formControlName="state" type="text">
                    <option value="null" selected=true disabled>State</option>
                    <option *ngFor="let state of stateListAU" [value]="state.stateName">{{state.stateName}}
                    </option>
                  </select>
                  <div *ngIf="
                                            (submit && jobControls.state.invalid) ||
                                            (jobControls.state.invalid &&
                                              (jobControls.state.dirty ||
                                                jobControls.state.touched))
                                          " class="error-msg">
                    <div *ngIf="jobControls.state.errors.required">
                      State is required
                    </div>
                  </div>
                </div>
                <div class="col-sm-6" *ngIf="jobPostForm.value.country!='AU'&&
                                                                                    jobPostForm.value.country!='IN'&&
                                                                                    jobPostForm.value.country!='CA'&&
                                                                                    jobPostForm.value.country!='US'">
                  <label for="location" class="control-label required-field font-bold">State</label>
                  <input type="text" maxlength="51" placeholder="State" formControlName="state"
                    class="form-control input-sm">
                  <div *ngIf="
                                                (submit && jobControls.state.invalid) ||
                                                (jobControls.state.invalid &&
                                                  (jobControls.state.dirty ||
                                                    jobControls.state.touched))
                                              " class="error-msg">
                    <div *ngIf="jobControls.state.errors.required">
                      State is required
                    </div>
                    <div *ngIf="jobControls.state.errors.maxword">
                      {{FORMERROR.STATE_MAX}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row pt-7">
                <div class="col-sm-6">
                  <label for="location" class="control-label required-field font-bold">City</label>
                  <input maxlength="51" type="text" placeholder="City" formControlName="city"
                    class="form-control input-sm">
                  <div *ngIf="
                                                (submit && jobControls.city.invalid) ||
                                                (jobControls.city.invalid &&
                                                  (jobControls.city.dirty ||
                                                    jobControls.city.touched))
                                              " class="error-msg">
                    <div *ngIf="jobControls.city.errors.required">
                      City is required
                    </div>
                    <div *ngIf="jobControls.city.errors.maxword">
                      {{FORMERROR.CITY_MAX}}
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <label for="location" class="control-label required-field font-bold">Zip Code</label>
                  <input type="text" maxlength="12" placeholder="Zip Code" formControlName="zipCode"
                    class="form-control input-sm">
                  <div *ngIf="
                                    (submit && jobControls.zipCode.invalid) ||
                                    (jobControls.zipCode.invalid &&
                                      (jobControls.zipCode.dirty ||
                                      jobControls.zipCode.touched))
                                  " class="error-msg">
                    <div *ngIf="jobControls.zipCode.errors.required">
                      Zipcode is required
                    </div>
                    <div class="w-wrap" *ngIf="jobControls.zipCode.errors.minword">
                      {{FORMERROR.ZIPCODE_MIN}}
                    </div>
                    <div class="w-wrap" *ngIf="jobControls.zipCode.errors.maxword">
                      {{FORMERROR.ZIPCODE_MAX}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <label for="duration" class="control-label required-field font-bold">Duration</label>
            </div>
            <div class="col-sm-12" style="padding-bottom: 15px;">
              <div class="row">
                <div class="col-sm-6 pl-0" style="padding-bottom: 15px;">
                  <select formControlName="duration" class="form-control input-sm">
                    <option [ngValue]="null" disabled> Duration</option>
                    <option *ngFor="let year of years" [ngValue]="year">{{year}}</option>
                  </select>

                  <div *ngIf="(submit && jobControls.duration.invalid || jobControls.duration.touched)"
                    class="error-msg">
                    <div class="tar-job" *ngIf="jobControls.duration.errors?.required">
                      Duration is required
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 pr-0" style="padding-bottom: 15px;">
                  <select type="text" formControlName="durationType" class="form-control input-sm">
                    <option value=null disabled selected hidden>Type</option>
                    <option *ngFor="let durationType of durationTypeList"
                      [value]="durationType === 'Year' ? 'Years' : durationType">
                      {{durationType === 'Year' ? 'Years' : durationType}}
                    </option>
                  </select>
                  <div *ngIf="(submit && jobControls.durationType.invalid || jobControls.durationType.touched)"
                    class="error-msg w-wrap">
                    <div *ngIf="jobControls.durationType.errors?.required">
                      DurationType is required
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
          <div class="col-sm-12 p-0" style="padding-bottom: 15px!important;">
            <label for="duration" class="control-label required-field font-bold">Required Years of
              Experience</label>
            <div class="row">
              <div class="col-sm-6" style="padding-bottom: 15px;">
                <select type="text" formControlName="experienceFrom" class="form-control input-sm">
                  <option value=null disabled [selected]=true>From</option>
                  <option *ngFor="let year of years" [value]='year' [disabled]="validateBeginning(year)">
                    {{year}}
                  </option>
                </select>
                <div *ngIf=" (submit && jobControls.experienceFrom.invalid) ||
                                    (jobControls.experienceFrom.invalid &&
                                      (jobControls.experienceFrom.dirty ||
                                        jobControls.experienceFrom.touched))
                                  " class="error-msg">
                  <div *ngIf="jobControls.experienceFrom.errors?.required">
                    From Year is required
                  </div>
                </div>
              </div>
              <div class="col-sm-6" style="padding-bottom: 15px;">
                <select type="text" formControlName="experienceTo" class="form-control input-sm">
                  <option value=null disabled [selected]=true>To</option>
                  <option *ngFor="let year of Toyears" [value]='year' [disabled]="validateLast(year)">{{year}}
                  </option>
                </select>
                <div *ngIf="
                                    (submit && jobControls.experienceTo.invalid) ||
                                    (jobControls.experienceTo.invalid &&
                                      (jobControls.experienceTo.dirty ||
                                        jobControls.experienceTo.touched))
                                  " class="error-msg">
                  <div *ngIf="jobControls.experienceTo.errors?.required">
                    To Year is required
                  </div>
                </div>
              </div>
            </div>
          </div> 
          <div class="row" style="padding-bottom: 15px;">
            <div class="col-sm-6">
              <div class="row">
                <div class="col-sm-12" style="padding-bottom: 15px;">
                  <label for="payType" class="control-label required-field font-bold">Pay Type</label>
                  <select (change)="onChangePayType($event.target.value, 'jobs')" type="text" formControlName="payType"
                    class="form-control input-sm">
                    <option value=null disabled selected hidden>Choose Type</option>
                    <option *ngFor="let list of payTypeList" [value]="list">{{list}}</option>
                  </select>
                  <div *ngIf="
                        (submit && jobControls.payType.invalid) ||
                        (jobControls.payType.invalid &&
                          (jobControls.payType.dirty ||
                            jobControls.payType.touched))
                      " class="error-msg">
                    <div style="position: relative; top: 4px;" *ngIf="jobControls.payType.errors.required">
                      Pay Type is required
                    </div>
                  </div>
                </div>
             
              </div>
            </div>
            <div class="col-sm-6 ">
              <label for="workMode" class="control-label required-field font-bold">Work Mode</label>
              <select class="form-control input-sm" formControlName="workMode" type="text">
                <option [value]="null" disabled>Select Your Work Mode</option>
                <option value="Onsite">Onsite</option>
                <option value="Remote">Remote</option>
                <option value="Hybrid">Hybrid</option>
              </select>
              <div *ngIf="
                       (submit && jobControls.workMode.invalid) ||
                       (jobControls.workMode.invalid &&
                       (jobControls.workMode.dirty ||
                       jobControls.workMode.touched))  " class="error-msg">
                <div *ngIf="jobControls.workMode.errors.required">
                  Work Mode is required
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 p-0">
              <label for="targetRateFrom" class="control-label required-field font-bold">Target Rate
                Range</label>
          </div>
          <div class="row">
            <div class="col-sm-6" style="padding-bottom: 20px;">
              <div>
                <input maxlength="9" (keyup)="onTargetRateTyped($event.target.value)"
                  (keypress)="decimalFilter($event)" type="text" class="form-control input-sm" placeholder="From"
                  id="targetRate" formControlName="targetRateFrom">
                <div class="input-group-append">
                <span class="input-group-text currency-type-1">
                  <ng-container *ngIf="object?.source !== 'CEIPAL'; else ceipalCurFrom">
                  <label *ngIf="jobPostForm.value.country=='US' || jobPostForm.value.country==null" for="USD"
                    class="currency-type pt-7">USD</label>
                  <label *ngIf="jobPostForm.value.country=='IN'" for="INR" class="currency-type pt-7">INR</label>
                  <label *ngIf="jobPostForm.value.country=='CA'" for="CAD" class="currency-type pt-7">CAD</label>
                  <label *ngIf="jobPostForm.value.country=='AU'" for="AUD" class="currency-type pt-7">AUD</label>
                  <label
                    *ngIf="jobPostForm.value.country!='US' && jobPostForm.value.country!='IN' && jobPostForm.value.country!='CA' && jobPostForm.value.country!='AU' && jobPostForm.value.country!=null"
                    for="CUR" class="currency-type pt-7">CUR</label>
                  </ng-container>
                  <ng-template #ceipalCurFrom>
                    <label class="currency-type pt-7">{{ jobControls.country.dirty ? getCurrency(jobPostForm.value.country) : getJobCurrency(object) }}</label>
                  </ng-template>
                </span>
                </div>
              </div>
              <div *ngIf="
                    (submit && jobControls.targetRateFrom.invalid) ||
                    (jobControls.targetRateFrom.invalid &&
                      (jobControls.targetRateFrom.dirty ||
                        jobControls.targetRateFrom.touched))
                  " class="error-msg">
                <div *ngIf="jobControls.targetRateFrom.errors.required">
                  Target Rate is required
                </div>
                <div *ngIf="jobControls.targetRateFrom.errors.minword">
                  {{FORMERROR.TARGETRATE_MIN}}
                </div>
                <div *ngIf="jobControls.targetRateFrom.errors.maxword">
                  {{FORMERROR.TARGETRATE_MAX}}
                </div>

                <div *ngIf="jobControls.targetRateFrom.errors?.invalidDecimal&& !jobControls.targetRateFrom.errors.maxword">
                  {{FORMERROR.TARGETRATE_PATTERN}}
                </div>
              </div>
            </div>
            <div class="col-sm-6" style="padding-bottom: 20px;">
              <div>
                <input (keyup)="onTargetRateTyped($event.target.value)" type="text" maxlength="9"
                  class="form-control input-sm" placeholder="To" id="targetRate" (keypress)="decimalFilter($event)"
                  formControlName="targetRateTo">
                <div class="input-group-append">
                  <span class="input-group-text currency-type-2 right-16">
                    <ng-container *ngIf="object?.source !== 'CEIPAL'; else ceipalCurTo">
                    <label *ngIf="jobPostForm.value.country=='US' || jobPostForm.value.country==null" for="USD"
                      class="currency-type">USD</label>
                    <label *ngIf="jobPostForm.value.country=='IN'" for="INR" class="currency-type">INR</label>
                    <label *ngIf="jobPostForm.value.country=='CA'" for="CAD" class="currency-type">CAD</label>
                    <label *ngIf="jobPostForm.value.country=='AU'" for="AUD" class="currency-type">AUD</label>
                    <label
                      *ngIf="jobPostForm.value.country!='US' && jobPostForm.value.country!='IN' && jobPostForm.value.country!='CA' && jobPostForm.value.country!='AU' && jobPostForm.value.country!=null"
                      for="CUR" class="currency-type">CUR</label>
                    </ng-container>
                    <ng-template #ceipalCurTo>
                      <label class="currency-type">{{ jobControls.country.dirty ? getCurrency(jobPostForm.value.country) : getJobCurrency(object) }}</label>
                    </ng-template>
                    </span>
                    </div>
                    </div>
              <div *ngIf="(submit ) ||
                                        ((jobControls.targetRateTo.dirty ||
                                            jobControls.targetRateTo.touched))
                                      " class="error-msg">
                <div *ngIf="jobControls.targetRateTo.errors?.required">
                  Target Rate is required
                </div>
                <div class="w-wrap" *ngIf="jobControls.targetRateTo.errors?.minword">
                  {{FORMERROR.TARGETRATE_MIN}}
                </div>
                <div *ngIf="jobControls.targetRateTo.errors?.maxword">
                  {{FORMERROR.TARGETRATE_MAX}}
                </div>
                <div class="w-wrap"
                  *ngIf="jobPostForm.errors && jobPostForm?.errors?.rangevalidation&&!jobControls.targetRateFrom.errors?.invalidDecimal">
                  Invalid target rate range
                </div>

                <div class="text-wrap"
                  *ngIf="jobControls.targetRateTo.errors?.invalidDecimal&& !jobControls.targetRateTo.errors.maxword">
                  {{FORMERROR.TARGETRATE_PATTERN}}
                </div>
              </div>
            </div>
          </div>
      
          <div class="col-sm-6 pl-0"> 
            <label class="control-label required-field font-bold">Publish To</label>
            <ng-select class="multiselectlable" [items]="networkGroups" bindLabel="name" bindValue="id"
              placeholder="Select networks" [multiple]="true" [closeOnSelect]="false" [(ngModel)]="selectedNetworks"
              formControlName="selectedNetworks" (change)="onNetworkSelectionChange(jobPostForm)">
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <ng-container *ngIf="item.type">
                  <ng-container *ngIf="index === 0 || networkGroups[index - 1].type !== item.type">
                    <div class="networktype">{{ item.type }}</div>
                  </ng-container>
                  <div class="ng-select-checkbox-label"
                    [class.marketplace-locked]="(membershipType === 'Free' || userType === 'JOB_SEEKER') && item.id === '1'"
                    [class.permission-disabled]="item.disabled">
                    <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
                    <span class="ng-select-checkbox-text" [attr.title]="item.name">{{ item.name }}</span>
                    <ng-icon name="tablerBan" style="font-size:10px;margin-left:6px;color:#e53e3e;" *ngIf="item.disabled" title="Disabled by admin"></ng-icon>
                  </div>
                </ng-container>
              </ng-template>
              <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
                <div class="selected-item" [attr.title]="item.name">
                  <span id="business_post_network_remove" class="ng-value-clear remove-icon" (click)="clear(item); $event.stopPropagation()"
                    *ngIf="!((membershipType === 'Free' || userType === 'JOB_SEEKER') && item.id === '1') && !isNetworkLocked(item.id) && !item.disabled">
                    ✕
                  </span>
                  <ng-icon name="tablerLock" style="font-size:10px;margin-right:4px;color:#8B5CF6;"
                    *ngIf="isNetworkLocked(item.id) && !item.disabled"></ng-icon>
                  <ng-icon name="tablerBan" style="font-size:10px;margin-right:4px;color:#e53e3e;"
                    *ngIf="item.disabled"></ng-icon>
                  <span class="ng-value-label">{{ item.name }}</span>
                </div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="(submit && jobControls.selectedNetworks.invalid) ||
                              (jobControls.selectedNetworks.invalid && (jobControls.selectedNetworks.dirty || jobControls.selectedNetworks.touched))"
              class="error-msg">
              <div *ngIf="jobControls.selectedNetworks.errors.required">
                Publish to is required
              </div>
            </div>
          </div>

          <div class="col-sm-6" style="padding-top: 15px;">
            <div class="security-clearance-card"
              [class.active]="jobPostForm.get('securityClearance')?.value">
              <div class="security-clearance-card__info">
                <div class="security-clearance-card__icon">
                  <ng-icon name="tablerShieldLock"></ng-icon>
                </div>
                <div class="security-clearance-card__text">
                  <span class="security-clearance-card__title">Security Clearance</span>
                </div>
              </div>
              <div class="security-clearance-card__action">
                <span class="security-clearance-card__status"
                  [class.active]="jobPostForm.get('securityClearance')?.value">
                  {{ jobPostForm.get('securityClearance')?.value ? 'Yes' : 'No' }}
                </span>
                <label class="platform-toggle-switch">
                  <input type="checkbox" formControlName="securityClearance" name="securityClearance">
                  <span class="platform-toggle-track">
                    <span class="platform-toggle-thumb"></span>
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Job Description section moved to top of form with JD parsing feature - commented out to avoid duplicate formControlName -->
      <!-- <div class=" row">
        <div class="col-sm-12 R-summary" style="margin-top:20px;">
          <label class="control-label required-field font-bold">Job Description</label>
          <div formControlName="jobDescription" [ngxSummernote]="config2" class="note-editor.note-frame"></div>
          <div *ngIf="
                  (submit && jobControls.jobDescription.invalid) ||
                  (jobControls.jobDescription.invalid &&
                    (jobControls.jobDescription.dirty ||
                      jobControls.jobDescription.touched))
                " class="error-msg">
            <div *ngIf="jobControls.jobDescription.errors.required">
              Job Description is required
            </div>
            <div *ngIf="jobControls.jobDescription.errors.minChar">
              Job Description should at least have {{ JOB_DESCRIPTION.min  }} Characters
            </div>
            <div *ngIf="jobControls.jobDescription.errors.maxChar">
              Job Description can have a maximum of {{ JOB_DESCRIPTION.max }} Characters
            </div>
          </div>
          <small>Maximum of {{ JOB_DESCRIPTION.max }} Characters allowed</small>
        </div>
      </div> -->
    </form>
  </div>
  <div class="custom-panel-footer">
    <div class="panel-footer">
      <div class="footer-flex">
        <button [ngClass]="{'disabled': disable_for_draft==true}" class="btn btn-default"
          (click)="cancelJob()">Cancel</button>
        <button class="btn  btn-primary" type="submit"
          *ngIf="object?.status!='DRAFTED'&& object?.status!='ACTIVE'&& object?.status!='AWAITING HOST'&& (object?.status=='INACTIVE_DUE_TO_LOW_CREDITS'||  object?.status=='INACTIVE'||  object?.status=='ON HOLD'|| object?.status=='FILLED'&&object?.status=='CLOSED'|| object?.status=='DEACTIVATED') "
          (click)="saveJob('ACTIVE')">Activate</button>
        <button [ngClass]="{'disabled': disable_for_draft==true}" class="btn  btn-primary" type="submit"
          *ngIf="object?.status!='ACTIVE'&& object?.status!='INACTIVE_DUE_TO_LOW_CREDITS'&& object?.status!='INACTIVE'&&  object?.status!='ON HOLD'&& object?.status!='FILLED'&&object?.status!='CLOSED' &&object?.status!='DEACTIVATED' && object?.status!='AWAITING HOST'"
          (click)="saveJob('DRAFTED')">Save as Draft</button>
        <button class="btn  btn-primary" type="submit"
          *ngIf="object?.status!='DRAFTED' && (object?.status=='AWAITING HOST'|| object?.status=='ACTIVE') "
          (click)="saveJob('ACTIVE')">Update</button>
        <button class="btn  btn-primary" type="submit"
          *ngIf="object?.status=='DRAFTED'|| object?.status!='ACTIVE'&& object?.status!='INACTIVE_DUE_TO_LOW_CREDITS'&&  object?.status!='INACTIVE'&&  object?.status!='ON HOLD'&& object?.status!='FILLED'&&object?.status!='CLOSED'&& object?.status!='DEACTIVATED'&& object?.status!='AWAITING HOST'"
          (click)="saveJob('ACTIVE')">Update</button>
      </div>
    </div>
  </div>
</ng-template>
